// front-end/src/config/userMapping.ts
/**
 * Configurazione mapping username -> email per login
 * Siccome Supabase richiede email, mappiamo gli username
 */

export const USER_MAPPINGS: Record<string, string> = {
  'admin': 'aiautomationita@gmail.com',
};

/**
 * Risolve username in email per login
 */
export function resolveEmailForLogin(usernameOrEmail: string): string {
  // Se è già un'email, usala
  if (usernameOrEmail.includes('@')) {
    return usernameOrEmail;
  }
  
  // Cerca nei mapping
  const mappedEmail = USER_MAPPINGS[usernameOrEmail.toLowerCase()];
  if (mappedEmail) {
    return mappedEmail;
  }
  
  // Default: aggiungi dominio locale
  return `${usernameOrEmail}@aiagent.local`;
}